// Common Success Handler Function

import store from '../store';

export default response => {
  const { status } = response;

  switch (status) {
    case 201:
      store.commit('snackbar/setSnack', {
        status: 'success',
        text: this.$t('MESSAGE.SUCCESS')
      });
      break;

    default:
      break;
  }
};
